/*
 * @Author: your name
 * @Date: 2020-06-29 09:34:55
 * @LastEditTime: 2020-07-21 15:40:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Parts_APP\src\utils\request.js
 */
import axios from 'axios'
import store from '@/store'
import { getToken, getTokens } from '@/utils/auth'
import router from '../router'
import { Dialog, Toast } from 'vant'
// 创建 axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 300000, // request timeout
    headers: { 'Content-Type': 'application/json; charset=utf-8' }
})
var errshow = true

// 请求拦截
service.interceptors.request.use(
    config => {
        // if (store.getters.token) {
        //     if (store.getters.token !== getToken()) {
        //         window.location.reload(true)
        //     }
        //     // let each request carry token
        //     // ['X-Token'] is a custom headers key
        //     // please modify it according to the actual situation
        //     // config.headers['X-Token'] = getToken()
        //     config.headers['Authorization'] = 'Bearer ' + getToken()
        // }
        console.log(config.headers, 'getTokensgetTokensgetTokensgetTokens')
        if (store.getters.token) {
            if (store.getters.token !== getToken()) {
                window.location.reload(true)
            }
            if (config.url.indexOf('api-p-report') != -1 || config.url.indexOf('api-p-base') != -1 || config.url.indexOf('api-wh') != -1 || config.url.indexOf('api-mt') != -1 || config.url.indexOf('api-p-rbac') != -1 || config.url.indexOf('api-equipstore') != -1) {
                if (getTokens()) {
                    config.headers['Authorization'] = 'Bearer ' + getTokens() // 让每个请求携带自定义token 请根据实际情况自行修改
                }
            } else {
                if (getToken()) {
                    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
                }
            }
        }
        if (config.responseType === 'arraybuffer') {
            errshow = false
        } else {
            errshow = true
        }
        return config
        // if (config.responseType === 'arraybuffer') {
        //     errshow = false
        // } else {
        //     errshow = true
        // }
        // showFullScreenLoading()
    }
)

// 响应拦截
service.interceptors.response.use(
    // 自定义 code 标识请求状态
    response => {
        console.log('请求成功')
        let res = null
        if (!errshow) {
            var enc = new TextDecoder('utf-8')
            try {
                res = JSON.parse(enc.decode(new Uint8Array(response.data)))
            } catch (error) {
                return response
            }
        } else {
            res = response.data
        }
        switch (res.code || res.Code) {
        case 200:
            return res
        case 1:
            return res
        case 2:
            return res
        case 202:
            return res
        case 401:
            Dialog.alert({
                message: '登录状态已过期，请重新登录！'
            }).then(() => {
                store.dispatch('user/logout')
                router.push('/login')
                var u = navigator.userAgent
                if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) { // 安卓手机
                    window.test.loginOut()
                }
            })
            return
        case 402:
            Dialog.alert({
                message: res.msg
            }).then(() => {
                store.dispatch('user/logout')
                router.push('/login')
                var u = navigator.userAgent
                if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) { // 安卓手机
                    window.test.loginOut()
                }
            })
            throw throwErro(res)
        default:
            // Dialog.alert({
            //     message: res.message
            // }).then(() => {
            //     Dialog.close()
            // })
            if (res.msg) {
                Toast(res.msg)
            } else if (res.message) {
                Toast(res.message)
            }
            console.log('errerrerrerr') // for debug
            console.log(res) // for debug
            //throw throwErro(res)
            return res
        }
    },
    // 通过 XMLHttpRequest 对象状态码标识
    error => {
        console.error(error)
        return Promise.reject(error)
    }
)
function throwErro(res) {
    var e = new Error()
    e.message = res.msg ? res.msg : res.message
    // tryHideFullScreenLoading()
    return e
}
export default service
